import React from "react";
import LoadingOverlay from "react-loading-overlay";

class RouteSpinner extends React.Component {
    render() {
        return (
            <div>
                {this.props.loading ? (
                    <LoadingOverlay
                        active={this.props.loading}
                        spinner
                        fadeSpeed={0}
                        text='Loading...'
                        styles={{
                            spinner: (base) => ({
                                ...base,
                                width: "100px",
                                "& svg circle": {
                                    stroke: "#00A550",
                                },
                            }),
                        }}
                    ></LoadingOverlay>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default RouteSpinner;
